/* ============================================
   OJAR GIFT BOX BUILDER — JAVASCRIPT (v2 — i18n)
   Complete flow: Step 1 → Step 2 → Step 3
   
   v2 Changes:
   - Reads translations from window.ojGiftBoxTranslations (injected by Liquid)
   - All box names, instructions, messages now translatable via Translate & Adapt
   - Fallback to English defaults if translations not available
   ============================================ */

(function() {
  'use strict';

  // ===== Translation Helper =====
  // Reads from window.ojGiftBoxTranslations (set by Liquid template)
  // Falls back to English defaults if not available
  const T = window.ojGiftBoxTranslations || {};
  
  function getBoxTranslation(boxType, key) {
    return (T.boxes && T.boxes[boxType] && T.boxes[boxType][key]) || '';
  }
  
  function getSubstepTranslation(boxType, index, key) {
    const box = T.boxes && T.boxes[boxType];
    if (box && Array.isArray(box.substeps) && box.substeps[index]) {
      return box.substeps[index][key] || '';
    }
    return '';
  }
  
  function getMessage(key, fallback) {
    return (T.messages && T.messages[key]) || fallback || '';
  }

  // ===== Box Configuration =====
  // Names and instructions are pulled from translations (Translate & Adapt manageable)
  const BOX_CONFIGS = {
    'perfect-pair': {
      name: getBoxTranslation('perfect-pair', 'name') || 'The Perfect Pair',
      image: 'https://cdn.shopify.com/s/files/1/0613/2898/2131/files/PERFECT_PAIR.jpg?v=1780401616',
      flow: 'single-category',
      categories: ['edp-100ml'],
      required: 2,
      instruction: getBoxTranslation('perfect-pair', 'instruction') || 'Add Any 2'
    },
    'ultimate-coffret': {
      name: getBoxTranslation('ultimate-coffret', 'name') || 'The Ultimate Coffret',
      image: 'https://cdn.shopify.com/s/files/1/0613/2898/2131/files/THE_ULTIMATE_COFFRET.jpg?v=1780401588',
      flow: 'multi-substep',
      substeps: [
        { 
          category: 'edp-100ml', 
          label: getSubstepTranslation('ultimate-coffret', 0, 'label') || '100ml EDP/Extrait', 
          required: 1, 
          instruction: getSubstepTranslation('ultimate-coffret', 0, 'instruction') || 'Add Any 1 from 100ml EDP / Extrait De Parfum' 
        },
        { 
          category: '15ml', 
          label: getSubstepTranslation('ultimate-coffret', 1, 'label') || '15ml EDP', 
          required: 1, 
          instruction: getSubstepTranslation('ultimate-coffret', 1, 'instruction') || 'Add Any 1 from 15ml EDP' 
        },
        { 
          category: 'absolute', 
          label: getSubstepTranslation('ultimate-coffret', 2, 'label') || '20ml Absolute', 
          required: 1, 
          instruction: getSubstepTranslation('ultimate-coffret', 2, 'instruction') || 'Add Any 1 from 20ml Absolute Oil' 
        }
      ],
      required: 3
    },
    'collectors-edition': {
      name: getBoxTranslation('collectors-edition', 'name') || "The Collector's Edition",
      image: 'https://cdn.shopify.com/s/files/1/0613/2898/2131/files/Collector_s_Edition.jpg?v=1780401565',
      flow: 'multi-substep',
      substeps: [
        { 
          category: 'edp-100ml', 
          label: getSubstepTranslation('collectors-edition', 0, 'label') || '100ml EDP/Extrait', 
          required: 6, 
          instruction: getSubstepTranslation('collectors-edition', 0, 'instruction') || 'Add Any 6 EDP / Extrait De Parfum' 
        },
        { 
          category: 'absolute', 
          label: getSubstepTranslation('collectors-edition', 1, 'label') || '20ml Absolute', 
          required: 6, 
          instruction: getSubstepTranslation('collectors-edition', 1, 'instruction') || 'Add Any 6 from 20ml Absolute Oil' 
        }
      ],
      required: 12
    }
  };

  // ===== State =====
  // CURRENCY FIX: Use OjarCurrency native system (matches rest of site)
  const state = {
    currentStep: 1,
    selectedBox: null,
    selectedProducts: [], // [{ id, handle, title, price, image, category }]
    currency: (window.OjarCurrency && typeof window.OjarCurrency.getCurrentCurrency === 'function') 
              ? window.OjarCurrency.getCurrentCurrency() 
              : (window.Shopify?.currency?.active || 'USD'),
    currentSubstep: 0 // For Ultimate Coffret
  };

  // ===== Elements =====
  const wrapper = document.querySelector('.oj-gbb-wrapper');
  if (!wrapper) return;

  const boxCards = wrapper.querySelectorAll('.oj-gbb__box-card');
  const step1ContinueBtn = wrapper.querySelector('[data-action="next-to-step-2"]');
  const step2BackBtn = wrapper.querySelector('[data-action="back-to-step-1"]');
  const step2ContinueBtn = wrapper.querySelector('[data-action="next-to-step-3"]');
  const step3BackBtn = wrapper.querySelector('[data-action="back-to-step-2"]');
  const addToCartBtn = wrapper.querySelector('[data-action="add-to-cart"]');

  // ===== Step 1: Box Selection =====
  boxCards.forEach(card => {
    card.addEventListener('click', function() {
      boxCards.forEach(c => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
      
      state.selectedBox = {
        type: card.dataset.boxType,
        name: card.dataset.boxName,
        rule: card.dataset.boxRule
      };
      
      step1ContinueBtn.classList.remove('oj-gbb__btn--disabled');
      step1ContinueBtn.disabled = false;
      
      console.log('[OJ GBB] Selected box:', state.selectedBox);
    });
  });

  step1ContinueBtn.addEventListener('click', function() {
    if (!state.selectedBox) return;
    state.selectedProducts = []; // Reset
    state.currentSubstep = 0;
    setupStep2();
    goToStep(2);
  });

  // ===== Step 2: Setup based on box type =====
  function setupStep2() {
    const config = BOX_CONFIGS[state.selectedBox.type];
    const boxImg = document.getElementById('oj-step2-box-img');
    const boxPlaceholder = document.getElementById('oj-step2-box-placeholder');
    const boxName = document.getElementById('oj-step2-box-name');
    const instructionEl = document.getElementById('oj-step2-instruction');
    const requiredCountEl = document.getElementById('oj-step2-required-count');
    const selectedCountEl = document.getElementById('oj-step2-selected-count');
    const substepsContainer = document.getElementById('oj-step2-substeps');
    
    // Box image
    if (config.image) {
      boxImg.src = config.image;
      boxImg.alt = config.name;
      boxImg.style.display = 'block';
      boxPlaceholder.style.display = 'none';
    } else {
      boxImg.style.display = 'none';
      boxPlaceholder.style.display = 'flex';
      boxName.textContent = config.name;
    }
    
    selectedCountEl.textContent = '0';
    
    if (config.flow === 'single-category') {
      // Perfect Pair
      instructionEl.textContent = config.instruction;
      requiredCountEl.textContent = config.required;
      substepsContainer.style.display = 'none';
      showCategoryGrid(config.categories[0]);
    } else if (config.flow === 'multi-substep') {
      // Ultimate Coffret OR Collector's Edition (any multi-substep box)
      substepsContainer.style.display = 'block';
      setupMultiSubstep(0);
    }
    
    updateProductSelections();
  }

  function setupMultiSubstep(substepIndex) {
    // Use current box's config (works for both Ultimate Coffret and Collector's Edition)
    const config = BOX_CONFIGS[state.selectedBox.type];
    const substep = config.substeps[substepIndex];
    const instructionEl = document.getElementById('oj-step2-instruction');
    const requiredCountEl = document.getElementById('oj-step2-required-count');
    const selectedCountEl = document.getElementById('oj-step2-selected-count');
    
    instructionEl.textContent = substep.instruction;
    requiredCountEl.textContent = substep.required;
    
    // Count items in current substep's category
    const currentCategoryCount = state.selectedProducts.filter(p => p.category === substep.category).length;
    selectedCountEl.textContent = currentCategoryCount;
    
    // Update substep indicators
    const substepEls = wrapper.querySelectorAll('.oj-gbb__substep');
    substepEls.forEach((el, idx) => {
      el.classList.remove('oj-gbb__substep--active', 'oj-gbb__substep--completed');
      // Hide substeps that are not in current config
      if (idx >= config.substeps.length) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      
      // Update label to match current substep (translated)
      const labelEl = el.querySelector('.oj-gbb__substep-label');
      if (labelEl && config.substeps[idx]) {
        labelEl.textContent = config.substeps[idx].label;
      }
      
      if (idx < substepIndex) {
        el.classList.add('oj-gbb__substep--completed');
      } else if (idx === substepIndex) {
        el.classList.add('oj-gbb__substep--active');
      }
    });
    
    state.currentSubstep = substepIndex;
    showCategoryGrid(substep.category);
  }

  function showCategoryGrid(category) {
    wrapper.querySelectorAll('.oj-gbb__products-grid').forEach(grid => {
      grid.dataset.active = (grid.dataset.category === category) ? 'true' : 'false';
    });
  }

  // ===== Product selection =====
  function updateProductSelections() {
    wrapper.querySelectorAll('.oj-gbb__product-card').forEach(card => {
      const productId = card.dataset.productId;
      const isSelected = state.selectedProducts.some(p => p.id === productId);
      card.classList.toggle('is-selected', isSelected);
    });
  }

  function handleProductClick(card) {
    const config = BOX_CONFIGS[state.selectedBox.type];
    const productId = card.dataset.productId;
    const activeGrid = card.closest('.oj-gbb__products-grid');
    const category = activeGrid.dataset.category;
    
    // CURRENCY FIX: Get price from OjarPriceData based on current currency
    // Falls back to data attribute if OjarPriceData not available
    let productPrice = 0;
    const productHandle = card.dataset.productHandle;
    
    if (window.OjarPriceData && window.OjarPriceData[productHandle]) {
      const priceObj = window.OjarPriceData[productHandle];
      productPrice = priceObj[state.currency] || priceObj['USD'] || 0;
    }
    
    // Fallback to data attribute if OjarPriceData missing or returned 0
    if (productPrice === 0) {
      productPrice = parseFloat(card.dataset.productPrice.replace(/[^0-9.]/g, '')) || 0;
    }
    
    const productData = {
      id: productId,
      handle: productHandle,
      title: card.dataset.productTitle,
      price: productPrice,
      image: card.dataset.productImage,
      category: category
    };
    
    const existingIdx = state.selectedProducts.findIndex(p => p.id === productId);
    
    if (existingIdx >= 0) {
      // Deselect
      state.selectedProducts.splice(existingIdx, 1);
    } else {
      // Select - check limits
      if (config.flow === 'single-category') {
        if (state.selectedProducts.length >= config.required) {
          console.log('[OJ GBB] Max products reached');
          return;
        }
        state.selectedProducts.push(productData);
      } else if (config.flow === 'multi-substep') {
        const substep = config.substeps[state.currentSubstep];
        const currentCategoryCount = state.selectedProducts.filter(p => p.category === substep.category).length;
        if (currentCategoryCount >= substep.required) {
          console.log('[OJ GBB] Max for this substep reached');
          return;
        }
        state.selectedProducts.push(productData);
      }
    }
    
    updateProductSelections();
    updateCounterAndButton();
    
    console.log('[OJ GBB] Selected products:', state.selectedProducts);
  }

  function updateCounterAndButton() {
    const config = BOX_CONFIGS[state.selectedBox.type];
    const selectedCountEl = document.getElementById('oj-step2-selected-count');
    
    if (config.flow === 'single-category') {
      selectedCountEl.textContent = state.selectedProducts.length;
      const isComplete = state.selectedProducts.length === config.required;
      step2ContinueBtn.disabled = !isComplete;
      step2ContinueBtn.classList.toggle('oj-gbb__btn--disabled', !isComplete);
    } else if (config.flow === 'multi-substep') {
      const substep = config.substeps[state.currentSubstep];
      const currentCategoryCount = state.selectedProducts.filter(p => p.category === substep.category).length;
      selectedCountEl.textContent = currentCategoryCount;
      
      const substepComplete = currentCategoryCount === substep.required;
      const isLastSubstep = state.currentSubstep === config.substeps.length - 1;
      
      if (substepComplete && !isLastSubstep) {
        // Auto-advance to next substep after short delay
        setTimeout(() => {
          setupMultiSubstep(state.currentSubstep + 1);
        }, 600);
      }
      
      // Enable continue only when all 3 selected
      const allSelected = state.selectedProducts.length === config.required;
      step2ContinueBtn.disabled = !allSelected;
      step2ContinueBtn.classList.toggle('oj-gbb__btn--disabled', !allSelected);
    }
  }

  // Attach click handlers to all product cards
  wrapper.querySelectorAll('.oj-gbb__product-card').forEach(card => {
    card.addEventListener('click', () => handleProductClick(card));
  });

  // ===== Step 2 Navigation =====
  step2BackBtn.addEventListener('click', () => goToStep(1));
  
  step2ContinueBtn.addEventListener('click', function() {
    if (step2ContinueBtn.disabled) return;
    updatePreview();
    goToStep(3);
  });

  // ===== Step 3 Navigation =====
  step3BackBtn.addEventListener('click', () => goToStep(2));

  // ===== Step 3: Preview =====
  function updatePreview() {
    const config = BOX_CONFIGS[state.selectedBox.type];
    
    // Box image
    const previewImg = document.getElementById('oj-preview-box-img');
    const previewPlaceholder = document.getElementById('oj-preview-box-placeholder');
    const previewName = document.getElementById('oj-preview-box-name');
    const previewTitle = document.getElementById('oj-preview-box-title');
    
    if (config.image) {
      previewImg.src = config.image;
      previewImg.alt = config.name;
      previewImg.style.display = 'block';
      previewPlaceholder.style.display = 'none';
    } else {
      previewImg.style.display = 'none';
      previewPlaceholder.style.display = 'flex';
      previewName.textContent = config.name;
    }
    
    previewTitle.textContent = config.name.toUpperCase();
    
    // Products
    const productsContainer = document.getElementById('oj-preview-products');
    productsContainer.innerHTML = state.selectedProducts.map(p => `
      <div class="oj-gbb__preview-product-card">
        <div class="oj-gbb__preview-product-image">
          ${p.image ? `<img src="${p.image}" alt="${p.title}" loading="lazy">` : `<span>${p.title}</span>`}
        </div>
        <h4 class="oj-gbb__preview-product-name">${p.title.toUpperCase()}</h4>
      </div>
    `).join('');
    
    // Pricing
    const subtotal = state.selectedProducts.reduce((sum, p) => sum + p.price, 0);
    const discount = subtotal * 0.20;
    const total = subtotal - discount;
    
    document.getElementById('oj-preview-subtotal').textContent = formatCurrency(subtotal);
    document.getElementById('oj-preview-discount').textContent = '-' + formatCurrency(discount);
    document.getElementById('oj-preview-total').textContent = formatCurrency(total);
    
    console.log('[OJ GBB] Preview updated:', { subtotal, discount, total, currency: state.currency, products: state.selectedProducts });
  }

  // ===== Add to Cart =====
  addToCartBtn.addEventListener('click', async function() {
    if (!state.selectedBox || state.selectedProducts.length === 0) {
      alert(getMessage('selectFirst', 'Please select products first.'));
      return;
    }

    // Disable button + show loading
    addToCartBtn.disabled = true;
    const originalBtnText = addToCartBtn.textContent;
    addToCartBtn.textContent = getMessage('adding', 'ADDING...');

    try {
      // Generate unique group ID for this gift box
      const groupId = 'gbb-' + Date.now() + '-' + Math.random().toString(36).substr(2, 6);
      
      // Get variant IDs for selected products (need to fetch from product handles)
      const cartItems = [];
      
      for (let i = 0; i < state.selectedProducts.length; i++) {
        const product = state.selectedProducts[i];
        
        // Fetch product to get first variant ID
        const productData = await fetchProductByHandle(product.handle);
        if (!productData || !productData.variants || productData.variants.length === 0) {
          throw new Error(`Variant not found for ${product.title}`);
        }
        
        const variantId = productData.variants[0].id;
        
        cartItems.push({
          id: variantId,
          quantity: 1,
          properties: {
            '_gift_box': 'true',
            '_gift_box_type': state.selectedBox.type,
            '_gift_box_name': state.selectedBox.name,
            '_gift_box_group_id': groupId,
            '_gift_box_discount_percent': '20',
            '_gift_box_item_index': (i + 1).toString(),
            '_gift_box_total_items': state.selectedProducts.length.toString()
          }
        });
      }
      
      console.log('[OJ GBB] Cart items to add:', cartItems);
      
      // Add all items to cart with sections render
      // sections parameter tells Shopify to return fresh HTML for cart-drawer
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          items: cartItems,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: '/cart'
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }
      
      const result = await response.json();
      console.log('[OJ GBB] Successfully added to cart:', result);
      
      // Success feedback (translated)
      addToCartBtn.textContent = getMessage('addedSuccess', 'ADDED TO CART ✓');
      addToCartBtn.style.background = '#0d5c2f';
      
      // CART DRAWER FIX: Pass sections from add response to avoid race condition
      setTimeout(() => {
        openCartDrawer(result.sections);
      }, 800);
      
      // Reset button after delay
      setTimeout(() => {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalBtnText;
        addToCartBtn.style.background = '';
        // Reset builder to step 1
        resetBuilder();
      }, 2000);
      
    } catch (error) {
      console.error('[OJ GBB] Add to cart error:', error);
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = originalBtnText;
      // Translated error with {{ error }} placeholder support
      const errorTemplate = getMessage('addToCartError', 'Sorry, could not add to cart: {{ error }}. Please try again or contact support.');
      const errorMsg = errorTemplate.replace(/\{\{\s*error\s*\}\}/g, error.message);
      alert(errorMsg);
    }
  });

  // ===== Helper: Fetch product by handle =====
  async function fetchProductByHandle(handle) {
    try {
      const response = await fetch('/products/' + handle + '.js');
      if (!response.ok) return null;
      return await response.json();
    } catch(e) {
      console.error('[OJ GBB] Failed to fetch product:', handle, e);
      return null;
    }
  }


  // ===== Helper: Reset builder =====
  function resetBuilder() {
    state.selectedBox = null;
    state.selectedProducts = [];
    state.currentSubstep = 0;
    
    // Reset UI
    boxCards.forEach(c => c.classList.remove('is-selected'));
    step1ContinueBtn.classList.add('oj-gbb__btn--disabled');
    step1ContinueBtn.disabled = true;
    
    wrapper.querySelectorAll('.oj-gbb__product-card').forEach(card => {
      card.classList.remove('is-selected');
    });
    
    goToStep(1);
  }

  // ===== Helper: Open cart drawer (Dawn-style) =====
  // CART DRAWER FIX: Use preloaded sections from /cart/add.js response (no race condition)
  async function openCartDrawer(preloadedSections) {
    console.log('[OJ GBB] Opening cart drawer');
    
    try {
      // Step 1: Get cart drawer element
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (!cartDrawer) {
        console.warn('[OJ GBB] cart-drawer element not found, falling back to redirect');
        window.location.replace('/cart?refreshed=' + Date.now());
        return;
      }
      
      // Step 2: Get sections data (use preloaded from /cart/add.js response OR fetch fresh)
      let sections = preloadedSections;
      
      if (!sections || !sections['cart-drawer']) {
        console.log('[OJ GBB] No preloaded sections, fetching fresh');
        const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        if (!response.ok) {
          throw new Error('Failed to fetch sections');
        }
        sections = await response.json();
      } else {
        console.log('[OJ GBB] Using preloaded sections from add response');
      }
      
      const parser = new DOMParser();
      
      // Step 3: Update cart drawer content
      if (sections['cart-drawer']) {
        const newDrawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawer = newDrawerDoc.querySelector('cart-drawer');
        
        if (newDrawer) {
          // Replace inner content (preserves element + listeners)
          cartDrawer.innerHTML = newDrawer.innerHTML;
          
          // Remove is-empty class if items exist
          cartDrawer.classList.remove('is-empty');
        }
      }
      
      // Step 4: Update cart icon bubble
      if (sections['cart-icon-bubble']) {
        const newBubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const cartBubble = document.querySelector('#cart-icon-bubble');
        const newBubble = newBubbleDoc.querySelector('#cart-icon-bubble');
        
        if (cartBubble && newBubble) {
          cartBubble.innerHTML = newBubble.innerHTML;
        }
      }
      
      // Step 5: Small delay to let DOM settle, then open drawer
      setTimeout(() => {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Fallback: trigger via cart icon click
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) {
            cartIcon.click();
          } else {
            // Last resort: manual open
            cartDrawer.classList.add('active', 'animate', 'is-open');
            cartDrawer.removeAttribute('hidden');
            document.body.classList.add('overflow-hidden');
          }
        }
        
        console.log('[OJ GBB] Cart drawer opened successfully');
      }, 100);
      
    } catch (error) {
      console.error('[OJ GBB] Drawer open failed, falling back to redirect:', error);
      // Fallback to original redirect behavior
      window.location.replace('/cart?refreshed=' + Date.now());
    }
  }

      
  // ===== Utilities =====
  // CURRENCY FIX: Use OjarCurrency native system, refresh on each call
  function formatCurrency(amount) {
    // Refresh currency from OjarCurrency in case it changed
    const currentCurrency = (window.OjarCurrency && typeof window.OjarCurrency.getCurrentCurrency === 'function')
                            ? window.OjarCurrency.getCurrentCurrency()
                            : state.currency;
    
    // Determine decimal places based on currency
    const isHighValueCurrency = ['OMR', 'KWD', 'BHD'].includes(currentCurrency);
    const decimals = isHighValueCurrency ? 3 : 2;
    
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currentCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals
      }).format(amount);
    } catch(e) {
      return currentCurrency + ' ' + amount.toFixed(decimals);
    }
  }

  function goToStep(stepNumber) {
    wrapper.querySelectorAll('.oj-gbb__step-content').forEach(content => {
      content.classList.remove('oj-gbb__step-content--active');
    });
    
    const targetContent = wrapper.querySelector(`[data-step-content="${stepNumber}"]`);
    if (targetContent) {
      targetContent.classList.add('oj-gbb__step-content--active');
    }
    
    wrapper.querySelectorAll('.oj-gbb__step').forEach(step => {
      const num = parseInt(step.dataset.step);
      step.classList.remove('oj-gbb__step--active', 'oj-gbb__step--completed');
      
      if (num < stepNumber) {
        step.classList.add('oj-gbb__step--completed');
      } else if (num === stepNumber) {
        step.classList.add('oj-gbb__step--active');
      }
    });
    
    state.currentStep = stepNumber;
    wrapper.dataset.currentStep = stepNumber;
    
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
    console.log('[OJ GBB] Moved to step:', stepNumber);
  }

  // ===== Expose for debugging =====
  window.ojGiftBoxBuilder = {
    state: state,
    config: BOX_CONFIGS,
    translations: T,
    goToStep: goToStep
  };

  console.log('[OJ GBB] Initialized v2 — Currency:', state.currency, '— Translations loaded:', !!window.ojGiftBoxTranslations);

})();